export default __webpack_public_path__ + "static/media/services_invites.8d7d745c.jpg";